// Suppresses a specific React warning that originates inside
// `@ant-design/pro-components` -> ListToolBar -> rc-tooltip, which still calls
// `ReactDOM.findDOMNode` under React 18. The warning is library-side and cannot
// be fixed in our code; the filter only drops messages whose first format
// argument is the exact `findDOMNode is deprecated` text.

const FIND_DOM_NODE_WARNING_MARKER = 'findDOMNode is deprecated';

let installed = false;

export const suppressKnownReactWarnings = () => {
  if (installed || typeof window === 'undefined') {
    return;
  }
  installed = true;

  const originalConsoleError = console.error.bind(console);

  console.error = (...args: unknown[]) => {
    const first = args[0];
    if (
      typeof first === 'string' &&
      first.includes(FIND_DOM_NODE_WARNING_MARKER)
    ) {
      return;
    }
    originalConsoleError(...args);
  };
};
